import { render } from "./Statistic.vue?vue&type=template&id=24da6d80&scoped=true&ts=true"
import script from "./Statistic.ts?vue&type=script&lang=ts"
export * from "./Statistic.ts?vue&type=script&lang=ts"

import "./Statistic.scss?vue&type=style&index=0&id=24da6d80&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24da6d80"]])

export default __exports__